import React, { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

interface CandidatesBoardContext {
    jobIds: string[];
    assignee: string;
    disqualified: boolean;
    showClientName: boolean;
    showJobName: boolean;
    showAssigneeName: boolean;
}

const CandidatesBoardContext = createContext<CandidatesBoardContext>({
    assignee: undefined,
    disqualified: undefined,
    jobIds: undefined,
    showAssigneeName: false,
    showClientName: false,
    showJobName: false
});

interface CandidatesBoardProviderProps extends CandidatesBoardContext {
    children?: ReactNode;
}

const CandidatesBoardProvider = ({
    assignee,
    children,
    disqualified,
    jobIds,
    showAssigneeName,
    showClientName,
    showJobName
}: CandidatesBoardProviderProps): JSX.Element => {
    return (
        <CandidatesBoardContext.Provider
            value={{ assignee, disqualified, jobIds, showJobName, showAssigneeName, showClientName }}
        >
            {children}
        </CandidatesBoardContext.Provider>
    );
};

const useCandidatesBoard = () => useContext(CandidatesBoardContext);

export { CandidatesBoardProvider, useCandidatesBoard };
